import { t } from 'i18next';

import { CognitoExceptions } from 'interfaces/auth';

export const codeResponseErrorsMap = new Map<string, string>([
  [CognitoExceptions.CodeMismatchException, t('wrongConfirmationCodeError')],
  [CognitoExceptions.ExpiredCodeException, t('expiredConfirmationCodeError')],
]);
